module.exports = __webpack_public_path__ + "static/media/icon-quiz-3.2666740e.png";